import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Sissemaks

  <span style="color:#85c1dc;">**FI:**</span>
  Ennakkomaksu

  <span style="color:#85c1dc;">**RU:**</span>
  Авансовый взнос
*/
/* @__NO_SIDE_EFFECTS__ */
const m386 = msg(
  mf`Sissemaks`,
  mf`Ennakkomaksu`,
  mf`Авансовый взнос`,
)

export { m386 as 'w.menu.jm.sissemaks' }